/**
 * AIコード生成サービス
 * HTML/CSSコードを自然言語の指示から生成する
 */

export interface GenerateCodeRequest {
  prompt: string;
  existingCode?: string;
}

export interface GenerateCodeResponse {
  success: boolean;
  code: string;
  error?: string;
}

export class AICodeGenerationService {
  private static readonly API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /**
   * 自然言語の指示からHTML/CSSコードを生成
   * @param prompt ユーザーの指示（例: "中央にタイトルを表示してその下に特定のテキストを入れる。中央揃えでタイトルは太文字。"）
   * @param existingCode 既存のコード（オプション）
   * @returns 生成されたHTML/CSSコード
   */
  static async generateCode(
    prompt: string,
    existingCode?: string
  ): Promise<string> {
    try {
      const response = await fetch(`${this.API_BASE_URL}/api/generate-html-css`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          prompt,
          existingCode,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'コード生成に失敗しました');
      }

      const result: GenerateCodeResponse = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'コード生成に失敗しました');
      }

      return result.code;
    } catch (error) {
      console.error('AIコード生成エラー:', error);
      
      // 接続エラーの場合、より分かりやすいメッセージを表示
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        throw new Error(
          `サーバーに接続できません。\n` +
          `1. サーバーが起動しているか確認してください（cd server && npm start）\n` +
          `2. API URL: ${this.API_BASE_URL}\n` +
          `3. サーバーがポート3001でリッスンしているか確認してください`
        );
      }
      
      throw error;
    }
  }
}

